import React from "react";

const NoCameraIcon = () => {
    return (
        <div id="message-barcode" className="">
            <div className="noCamera">
                <svg
                    version="1.1"
                    xmlns="http://www.w3.org/2000/svg"
                    xmlnsXlink="http://www.w3.org/1999/xlink"
                    x="0px"
                    y="0px"
                    viewBox="0 0 45 38"
                    xmlSpace="preserve"
                    enableBackground="new 0 0 45 38"
                >
                    <path
                        className="cameraSt0"
                        d="M38.3,7h-6.4l-4-4H17.4l-4.8,4h-6C4.6,7,3,8.6,3,10.6v21c0,2,1.6,3.6,3.6,3.6h31.7c2,0,3.6-1.6,3.6-3.6v-21
                    C41.9,8.6,40.3,7,38.3,7z"
                    />
                    <g id="Ellipse_4">
                        <ellipse className="cameraSt1" cx="22.4" cy="20.2" rx="10.7" ry="10.3" />
                        <ellipse className="cameraSt2" cx="22.4" cy="20.2" rx="9.3" ry="8.8" />
                    </g>
                </svg>
            </div>
        </div>
    );
};

export default NoCameraIcon;
